import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  en: {
    // Nav
    features: 'Features', pricing: 'Pricing', customers: 'Customers', faq: 'FAQ', signIn: 'Sign in', startFreeTrial: 'Start Free Trial',
    // Hero
    tagline: "India's #1 Digital Freight Marketplace",
    heroTitle1: 'Move freight across India,', heroTitle2: 'effortlessly',
    heroDesc: 'Connect with 50,000+ verified truckers and shippers. Post loads, find return trucks, get GST-compliant e-LR & e-Way Bills, and settle payments via UPI \u2014 all in one platform.',
    startTrial: 'Start 1 Month Free Trial', watchDemo: 'Watch Demo',
    noCard: 'No credit card required', gstInvoices: 'GST invoices', upiPayments: 'UPI payments',
    // Stats
    verifiedTruckers: 'Verified Truckers', activeShippers: 'Active Shippers', citiesCovered: 'Cities Covered', paymentsSettled: 'Payments Settled/mo',
    // Sidebar
    dashboard: 'Dashboard', loadBoard: 'Load Board', truckBoard: 'Truck Board', fleetMap: 'Fleet Map', myLoads: 'My Loads', rateInsights: 'Rate Insights', documents: 'Documents', payments: 'Payments', subscription: 'Subscription', profile: 'Profile',
    upgradeNow: 'Upgrade Now', daysLeft: 'days left', freeTrial: 'Free Trial',
    // Dashboard
    namaste: 'Namaste', dashboardSubtitle: "Here's what's moving today across your fleet.",
    findLoads: 'Find Loads', postTruck: 'Post Truck',
    trialBanner: "You're on Free Trial \u2014", daysRemaining: 'days remaining',
    upgradeToPro: 'Upgrade to Pro', trialUpsell: 'Upgrade to Pro for unlimited loads, e-LR & priority payments \u2014 \u20b9500 + GST/month.',
    activeLoads: 'Active Loads', availableTrucks: 'Available Trucks', monthlyRevenue: 'Monthly Revenue', onTimeDelivery: 'On-Time Delivery',
    activeShipments: 'Active Shipments', trackYourTrips: 'Track your ongoing trips in real-time',
    liveLoads: 'Live Loads', viewAll: 'View all', seeAllLoads: 'See All Loads',
    topLaneRates: 'Top Lane Rates', laneInsightsDesc: 'Real-time freight rate insights across India',
    // Buttons
    postLoad: 'Post a Load', bookLoad: 'Book Load', hireTruck: 'Hire Truck', track: 'Track Live',
    // Language
    language: 'Language',
    // Voice notes
    holdToSpeak: 'Hold to speak', releaseToSend: 'Release to send', slideToCancel: 'Slide to cancel', voiceNote: 'Voice note', transcribing: 'Transcribing…', transcript: 'Transcript', showTranscript: 'Show transcript', recording: 'Recording',
  },
  hi: {
    features: 'सुविधाएं', pricing: 'मूल्य', customers: 'ग्राहक', faq: 'प्रश्न', signIn: 'साइन इन', startFreeTrial: 'फ्री ट्रायल शुरू करें',
    tagline: 'भारत का #1 डिजिटल फ्रेट मार्केटप्लेस',
    heroTitle1: 'पूरे भारत में माल भेजें,', heroTitle2: 'आसानी से',
    heroDesc: '50,000+ वेरिफाईड ट्रकर्स और शिपर्स से जुड़ें। लोड पोस्ट करें, रिटर्न ट्रक पाएं, GST-कंप्लायंट e-LR और e-Way Bill बनाएं, और UPI से भुगतान करें — सब कुछ एक ही प्लेटफ़ॉर्म पर।',
    startTrial: '1 महीने का मुफ्त ट्रायल शुरू करें', watchDemo: 'डेमो देखें',
    noCard: 'क्रेडिट कार्ड जरूरी नहीं', gstInvoices: 'GST इनवॉयस', upiPayments: 'UPI भुगतान',
    verifiedTruckers: 'वेरिफाईड ट्रकर्स', activeShippers: 'सक्रिय शिपर्स', citiesCovered: 'शहर कवर किए', paymentsSettled: 'भुगतान सेटल/महीना',
    dashboard: 'डैशबोर्ड', loadBoard: 'लोड बोर्ड', truckBoard: 'ट्रक बोर्ड', fleetMap: 'फ्लीट मैप', myLoads: 'मेरे लोड', rateInsights: 'रेट इनसाइट्स', documents: 'दस्तावेज', payments: 'भुगतान', subscription: 'सब्सक्रिप्शन', profile: 'प्रोफाइल',
    upgradeNow: 'अपग्रेड करें', daysLeft: 'दिन बाकी', freeTrial: 'मुफ्त ट्रायल',
    namaste: 'नमस्ते', dashboardSubtitle: 'आज आपके बेड़े में क्या चल रहा है, यहां देखें।',
    findLoads: 'लोड खोजें', postTruck: 'ट्रक पोस्ट करें',
    trialBanner: 'आप फ्री ट्रायल पर हैं —', daysRemaining: 'दिन बाकी',
    upgradeToPro: 'प्रो में अपग्रेड करें', trialUpsell: 'अनलिमिटेड लोड, e-LR और प्राथमिकता वाले भुगतान के लिए प्रो में अपग्रेड करें — ₹500 + GST/महीना।',
    activeLoads: 'सक्रिय लोड', availableTrucks: 'उपलब्ध ट्रक', monthlyRevenue: 'मासिक आय', onTimeDelivery: 'समय पर डिलिवरी',
    activeShipments: 'सक्रिय शिपमेंट्स', trackYourTrips: 'अपनी चल रही ट्रिप्स लाइव ट्रैक करें',
    liveLoads: 'लाइव लोड', viewAll: 'सभी देखें', seeAllLoads: 'सभी लोड देखें',
    topLaneRates: 'टॉप लेन के रेट', laneInsightsDesc: 'भारत भर में रियल-टाइम फ्रेट रेट जानकारी',
    postLoad: 'लोड पोस्ट करें', bookLoad: 'बुक करें', hireTruck: 'ट्रक बुक करें', track: 'लाइव ट्रैक',
    language: 'भाषा',
    holdToSpeak: 'दबाकर बोलें', releaseToSend: 'भेजने के लिए छोड़ें', slideToCancel: 'रद्द करने के लिए स्लाइड करें', voiceNote: 'वॉइस नोट', transcribing: 'लिखा जा रहा है…', transcript: 'लिखाई', showTranscript: 'लिखाई देखें', recording: 'रिकॉर्डिंग',
  }
};

const I18nContext = createContext({ lang: 'en', t: (k) => k, setLang: () => {} });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem('ezload_lang') || 'en');
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const setLang = (l) => { localStorage.setItem('ezload_lang', l); setLangState(l); };
  const t = (key) => (translations[lang] && translations[lang][key]) || translations.en[key] || key;
  return <I18nContext.Provider value={{ lang, t, setLang }}>{children}</I18nContext.Provider>;
}

export const useI18n = () => useContext(I18nContext);
